// extracted by mini-css-extract-plugin
module.exports = {"menu":"df5dab2e92--menu--pk9He","menu-item":"df5dab2e92--menu-item--gVGrr","menu-item--active":"df5dab2e92--menu-item--active--RueXq"};